/**
 * Onboarding status service
 * Migrated to use settingsStore for sync support
 * Onboarding flag uses standard last-write-wins sync behavior
 */

import { settingsStore, type OnboardingSetting } from './settingsStore';

const ONBOARDING_KEY = "completed";

/**
 * Check if onboarding has been completed
 * @returns Promise<boolean> - true if onboarding is complete, false otherwise
 */
export async function isOnboardingComplete(): Promise<boolean> {
  const setting = await settingsStore.get<OnboardingSetting>("onboarding", ONBOARDING_KEY, { completed: false });
  return setting.completed;
}

/**
 * Mark onboarding as complete
 * @returns Promise<void>
 */
export async function setOnboardingComplete(): Promise<void> {
  const now = new Date().toISOString();
  await settingsStore.save<OnboardingSetting>("onboarding", ONBOARDING_KEY, {
    completed: true,
    completedAt: now,
  });
}

/**
 * Reset onboarding status (mark as incomplete)
 * @returns Promise<void>
 */
export async function resetOnboardingStatus(): Promise<void> {
  await settingsStore.save<OnboardingSetting>("onboarding", ONBOARDING_KEY, {
    completed: false,
  });
}
